import React, { useRef, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./SearchPeople.scss";
import { InputText } from "primereact/inputtext";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import { Toast } from "primereact/toast";

const AttribuerDroits = (props) => {
  const [surname, setSurname] = useState("");
  const [firstname, setFirstname] = useState("");
  const [userList, setUserList] = useState([]);
  const signalToast = useRef(null);

  const handleRecherche = () => {
    let url = new URL(
      `${process.env.REACT_APP_BASE_URL_API}/users/search/people`
    );
    //Si les champs ne sont pas vides on ajoute les paramètres de recherche à l'url
    if (surname != "") {
      url.searchParams.set("surname", surname);
    }
    if (firstname != "") {
      url.searchParams.set("firstname", firstname);
    }

    axios
      .get(url.toString(), {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((response) => {
        if (response.data.length === 0)
          signalToast.current.show({
            severity: "info",
            summary: "Aucun résultat",
            detail: "Aucun utilisateur ne correspond à votre recherche",
            life: 3000,
          });
        setUserList(response.data);
      })
      .catch((error) =>
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        })
      );
  };

  return (
    <div className="search_people_component">
      <Toast ref={signalToast} />
      <div className="search_people_component_search">
        <div className="search_people_component_search_inputs">
          <div className="search_people_component_search_inputs_firstname">
            <label>Prénom</label>
            <InputText
              value={firstname}
              placeholder="Marie, Paul..."
              onChange={(e) => setFirstname(e.target.value)}
            />
          </div>
          <div className="search_people_component_search_inputs_surname">
            <label>Nom</label>
            <InputText
              value={surname}
              placeholder="Dupont, Gary..."
              onChange={(e) => setSurname(e.target.value)}
            />
          </div>
        </div>
        <BtnBleu
          btnTexte="Rechercher"
          btnAction={(e) => {
            e.preventDefault();
            handleRecherche();
          }}
        />
      </div>

      {userList.length > 0 && (
        <div className="search_people_component_results">
          {userList.map(
            (user, index) =>
              user.id !== props.auth.userConnected.id && (
                <span
                  key={index}
                  onClick={() => {
                    setFirstname(user.firstname);
                    setSurname(user.surname);
                    if (props.setUser) props.setUser(user);
                    else if (
                      props.setUserList &&
                      !props.userList.find((item) => item.id === user.id)
                    )
                      props.setUserList(props.userList.concat(user));
                    else
                      signalToast.current.show({
                        severity: "error",
                        summary: "Utilisateur déjà sélectionné",
                        detail: "Cet utilisateur a déjà été sélectionné",
                        life: 3000,
                      });
                  }}
                >
                  {user.firstname} {user.surname}
                </span>
              )
          )}
        </div>
      )}
    </div>
  );
};

AttribuerDroits.propTypes = {
  auth: PropTypes.object,
  setUser: PropTypes.func,
  setUserList: PropTypes.func,
  userList: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(AttribuerDroits);
